import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=13638d90&scoped=true"
import script from "./Review.vue?vue&type=script&lang=ts&setup=true"
export * from "./Review.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Review.vue?vue&type=style&index=0&id=13638d90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13638d90",
  null
  
)

export default component.exports